import script from "./RegistrationReports.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrationReports.vue?vue&type=script&setup=true&lang=ts"

import "./RegistrationReports.vue?vue&type=style&index=0&id=734b08c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\digi_aj\\source\\repos\\1ANAB_Vue_Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-734b08c8"]])

export default __exports__